import BigNumber from "bignumber.js";

const decimalsByNetwork = {
    FET: 18,
    AGIX: 8,
};

export const DECIMALS = decimalsByNetwork[process.env.REACT_APP_TOKEN_NAME];

const priceData = {
    fixed_price_model: "fixed_price",
    fixed_price_per_method: "fixed_price_per_method",
    precision: Math.pow(10, DECIMALS),
    divisibility: DECIMALS,
};

export const cogsToAgi = (cogs) =>
    new BigNumber(cogs).div(new BigNumber(priceData.precision)).toFixed(priceData.divisibility);

export const agiToCogs = (agi) =>
    String(new BigNumber(agi).multipliedBy(new BigNumber(priceData.precision)));

export const agiInDecimal = (agi) => parseFloat(agi).toFixed(priceData.divisibility);
